exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/main/widgets/modals/widget.modal.component.scss
// module id = ../../../../../src/app/main/widgets/modals/widget.modal.component.scss
// module chunks = 1